import type { Node as ProseMirrorNode } from "prosemirror-model";

export const INLINE_IMAGE_BLOB_MARKDOWN_PATTERN = /!\[[^\]]*]\(\s*blob:/i;

export const markdownHasLocalBlobImage = (value: string) =>
  INLINE_IMAGE_BLOB_MARKDOWN_PATTERN.test(value);

export const docHasUnresolvedInlineImageUpload = (doc: ProseMirrorNode) => {
  let pending = false;

  doc.descendants((node) => {
    if (node.type.name !== "image") {
      return true;
    }

    if (
      node.attrs.uploadStatus === "uploading" ||
      node.attrs.uploadStatus === "error" ||
      String(node.attrs.src || "").startsWith("blob:")
    ) {
      pending = true;
      return false;
    }

    return true;
  });

  return pending;
};
